function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

function slickCall() {  
  const thumbnailListContainer = document.querySelector('.carousel-thumbnail_slider');
  const MainListContainer = document.querySelector('.carousel-main_slider');
  
  if (!thumbnailListContainer || !MainListContainer) {
    console.log("Slick initialization skipped: Required containers not found.");
    return;
  }

  const thumbnailList = thumbnailListContainer.querySelectorAll('.slider__slide');
  thumbnailListContainer.classList.toggle('iglam-static-thumbnails', thumbnailList.length <= 4);
  const customNext = document.querySelector('.custom-next');
  const customPrev = document.querySelector('.custom-prev');
  const mainCustomNext = document.querySelector('button[name="next"]');
  const mainCustomPrev = document.querySelector('button[name="previous"]');

  // Initialize main slider
  if (!$(MainListContainer).hasClass('slick-initialized')) {
    $(MainListContainer).slick({
      fade: true,
      dots: false,
      arrows: true,
      nextArrow: mainCustomNext,
      prevArrow: mainCustomPrev,    
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      asNavFor: thumbnailListContainer,
      dotsClass: 'pagination',
      customPaging: function (slider, i) {
        return '<span class="page-link rounded-circle m-1 p-1" role="button"></span>';
      }
    });
  }

  // Initialize thumbnail slider if more than 2 thumbnails
  if (thumbnailList.length > 1 && !$(thumbnailListContainer).hasClass('slick-initialized')) {
    $(thumbnailListContainer).slick({
      dots: false,
      arrows: true,
      nextArrow: customNext,
      prevArrow: customPrev,     
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      adaptiveHeight: true,
      asNavFor: MainListContainer,
      focusOnSelect: true,
      dotsClass: 'pagination',
      customPaging: function (slider, i) {
        return '<span class="page-link rounded-circle m-1 p-1" role="button"></span>';
      }
    });
  }

  if (!thumbnailListContainer.dataset.iglamThumbnailBound) {
    thumbnailListContainer.dataset.iglamThumbnailBound = 'true';
    thumbnailListContainer.addEventListener('click', (event) => {
      const button = event.target.closest('button.thumbnail');
      const slide = button?.closest('[data-slick-index]');
      const index = Number.parseInt(slide?.dataset.slickIndex, 10);
      if (!button || !Number.isInteger(index) || !MainListContainer.classList.contains('slick-initialized')) return;
      event.preventDefault();
      $(MainListContainer).slick('slickGoTo', index);
    }, true);
    $(MainListContainer).on('afterChange.iglamThumbnails', (_event, _slider, index) => {
      thumbnailListContainer.querySelectorAll('button.thumbnail').forEach((button) => {
        const slideIndex = Number.parseInt(button.closest('[data-slick-index]')?.dataset.slickIndex, 10);
        if (slideIndex === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    });
  }
}
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('modal-open');    
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
     document.body.classList.remove('modal-open');    
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);


class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {    
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

 
  isSlideVisible(element, offset = 0) {
    if (!element) {
        console.warn("Element is undefined or null");
        return false; 
    }

    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;

    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
}

  
  onButtonClick(event) {    
    event.preventDefault();        
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;     
      this.updateSwiperMedias();
      const selectedDropdownSwatchValue = target.closest('.product-form__input').querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');    
      this.updateSwiperMedias();
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;    
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

   updateSwiperMedias() {   
    if (this.querySelector('.iglam-colour-picker')) return;
    const carouselTslider = document.querySelector('.carousel-thumbnail_slider');
     if(!carouselTslider) return;
    $('.carousel-thumbnail_slider').slick('unslick');
   slickCall();  
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.recommendation-items')) {
          this.classList.add('product-recommendations--loaded');
          this.initSlider(); 
          DTWishlist();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initSlider() {
    const slider = this.querySelector("[data-slick-slider]");
    const sliderList = this.querySelectorAll('.recommendation-items'); 
    if (!slider) return;
    const sliderOptions = slider.parentElement.getAttribute("data-slider-options");  
    if (!sliderOptions) return;
    const options = JSON.parse(sliderOptions);
    Object.keys(options).forEach(key => {
      if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
        options[key] = parseInt(options[key], 10);
      }
    });

    const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
    const loop = options.loop === "true" || options.loop === true;
    const centeredSlides = options.mode === "true" || options.mode === true;
    const pagination = options.dots === "true" || options.loop === true;

    const slickOptions = {
      infinite: loop,
      autoplay: !!autoplay,
      autoplaySpeed: autoplay,
      centerMode: centeredSlides,
      prevArrow: slider.parentElement.querySelector(".slick-prev"),
      nextArrow: slider.parentElement.querySelector(".slick-next"),
      dots: pagination,
      dotsClass: 'pagination pt-3',
      customPaging: function (slider, i) {
        return '<span class="page-link rounded-circle m-1 p-1"></span>';
      },
      lazyLoad: 'ondemand',
      slidesToShow: options.desktop,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 2560,
          settings: {
            slidesToShow: options.desktop,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: options.laptop,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: options.tablet,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: options.mobile,
          }
        }
      ],
      ...options.options 
    };

    $(slider).slick(slickOptions);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);



class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);


class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);


if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');            
        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            slickCall();
            DTWishlist();
            super.show(opener);                                           
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');          
          });
      }

      preprocessHTML(productElement) {        
        //this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }      
      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

      
        const modalCanvas = productElement.querySelectorAll('.canvas_block');        
        if (modalCanvas) modalCanvas.forEach((canvas) => canvas.remove());

        const modalAccordion = productElement.querySelectorAll('.product__accordion');        
        if (modalAccordion) modalAccordion.forEach((accordion) => accordion.remove());

        const blockPopup = productElement.querySelectorAll('.block-popup');        
        if (blockPopup) blockPopup.forEach((popup) => popup.remove());
        
        const shareButton = productElement.querySelector('.share_button');        
       if (shareButton) shareButton.remove();
        
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';        
        this.buyNowButton = this.querySelector('[data-iglam-buy-now]');
        this.buyNowButton?.addEventListener('click', this.onBuyNow.bind(this));
        
      }

      onBuyNow(evt) {
        evt.preventDefault();
        if (this.buyNowButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.form.reportValidity()) return;
        const data = new FormData(this.form);
        const variant = data.get('id');
        const quantity = data.get('quantity') || '1';
        if (!/^\d+$/.test(variant || '') || !/^\d+$/.test(quantity) || Number(quantity) < 1) return;
        const destination = new URL(`${this.buyNowButton.dataset.cartUrl}/${variant}:${quantity}`, window.location.origin);
        const properties = {};
        for (const [key, value] of data) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) {
          const bytes = new TextEncoder().encode(JSON.stringify(properties));
          destination.searchParams.set('properties', btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''));
        }
        window.location.assign(destination.href);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);       
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');            
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    console.log(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');  
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (this.buyNowButton) {
          if (disable) {
            this.buyNowButton.setAttribute('aria-disabled', 'true');
            this.buyNowButton.setAttribute('tabindex', '-1');
          } else {
            this.buyNowButton.removeAttribute('aria-disabled');
            this.buyNowButton.removeAttribute('tabindex');
          }
        }
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

class WDT_slideShow extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector("[data-slick-slider]");
        this.init();
    }

    init() {
        if (!this.slider || this.slider.children.length < 2) return;
        const sliderOptions = this.slider.parentElement.getAttribute("data-slider-options");    
        if (!sliderOptions) return;
        const options = JSON.parse(sliderOptions);
        
        Object.keys(options).forEach(key => {
            if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
                options[key] = parseInt(options[key], 10);
            }
        });

        const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
        const loop = options.loop === "true" || options.loop === true;      
        const pagination = options.dots === "true" || options.dots === true;
        const fade = options.fade === "true" || options.fade === true;

        const navContainer = this.slider.parentElement.querySelector('.slick-navigation');
        
        const slickOptions = {        
            fade: fade,
            cssEase: 'linear',          
            infinite: loop,
            autoplay: !!autoplay,
            autoplaySpeed: autoplay,            
            prevArrow: navContainer.querySelector(".slick-prev"),
            nextArrow: navContainer.querySelector(".slick-next"),
            dots: pagination,
            dotsClass: 'pagination',
            customPaging: function(slider, i) {
                return '<a class="dot">' + (i + 1) + '</a>'; 
            },
            lazyLoad: 'ondemand',
            slidesToShow: 1,        
            ...options.options 
        };

        $(this.slider).slick(slickOptions);      
    }
}

customElements.define('wdt-slideshow', WDT_slideShow);


// Keep offscreen carousel layout work out of the first paint.
class WDT_LazySlider extends HTMLElement {
    connectedCallback() {
        if (this.carouselInitialized || this.carouselObserver) return;
        this.slider = this.querySelector('[data-slick-slider]');
        if (!this.slider) return;
        const initialize = () => {
            if (!this.isConnected || this.carouselInitialized) return;
            this.carouselObserver?.disconnect();
            this.carouselObserver = null;
            this.init();
            this.carouselInitialized = true;
        };
        if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
            initialize();
            return;
        }
        this.carouselObserver = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) initialize();
        }, { rootMargin: '200px 0px' });
        this.carouselObserver.observe(this);
    }

    disconnectedCallback() {
        this.carouselObserver?.disconnect();
        this.carouselObserver = null;
    }
}

class WDT_Slider extends WDT_LazySlider {
    init() {    
        const sliderOptions = this.slider.parentElement.getAttribute("data-slider-options");    
        if (!sliderOptions) return;
        const options = JSON.parse(sliderOptions);        
        Object.keys(options).forEach(key => {
            if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
                options[key] = parseInt(options[key], 10);
            }
        });

        const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
        const loop = options.loop === "true" || options.loop === true;
        const centeredSlides = options.mode === "true" || options.mode === true;
        const pagination = options.dots === "true" || options.loop === true;

        const slickOptions = {
            infinite: loop,
            autoplay: !!autoplay,
            autoplaySpeed: autoplay,
            centerMode: centeredSlides,
            prevArrow: this.slider.parentElement.querySelector(".slick-prev"),
            nextArrow: this.slider.parentElement.querySelector(".slick-next"),               
            dots: pagination,            
    		dotsClass: 'pagination pt-3',
            customPaging: function (slider, i) {            
            var slideNumber = (i + 1),
            totalSlides = slider.slideCount;
              return '<spa class="page-link rounded-circle m-1 p-1"></span>';
           },
            lazyLoad: 'ondemand',
            slidesToShow: options.desktop,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 2560,
                    settings: {
                        slidesToShow: options.desktop,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: options.laptop,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: options.tablet,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: options.mobile,
                    }
                }
            ],
            ...options.options 
        };

        $(this.slider).slick(slickOptions);
    }
}

customElements.define('wdt-slick-slider', WDT_Slider);

class WDT_blog_Slider extends WDT_LazySlider {
    init() {    
        const sliderOptions = this.slider.parentElement.getAttribute("data-slider-options");    
        if (!sliderOptions) return;
        const options = JSON.parse(sliderOptions);        
        Object.keys(options).forEach(key => {
            if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
                options[key] = parseInt(options[key], 10);
            }
        });

        const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
        const loop = options.loop === "true" || options.loop === true;
        const centeredSlides = options.mode === "true" || options.mode === true;
        const pagination = options.dots === "true" || options.loop === true;

        const slickOptions = {
            infinite: loop,
            autoplay: !!autoplay,
            autoplaySpeed: autoplay,
            centerMode: centeredSlides,
            prevArrow: this.slider.parentElement.querySelector(".slick-prev"),
            nextArrow: this.slider.parentElement.querySelector(".slick-next"),               
            dots: pagination,            
    		dotsClass: 'pagination pt-3',
            customPaging: function (slider, i) {            
            var slideNumber = (i + 1),
            totalSlides = slider.slideCount;
              return '<spa class="page-link rounded-circle m-1 p-1"></span>';
           },
            lazyLoad: 'ondemand',
            slidesToShow: options.desktop,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 2560,
                    settings: {
                        slidesToShow: options.desktop,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: options.laptop,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: options.tablet,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: options.mobile,
                    }
                }
            ],
            ...options.options 
        };

        $(this.slider).slick(slickOptions);
    }
}

customElements.define('wdt-blog-slick-slider', WDT_blog_Slider);

class WDT_Fcollection extends WDT_LazySlider {
    connectedCallback() {
        this.slider = this.querySelector("[data-slick-slider]");
        if (!this.slider) return;
        if (!this.progressBar) {
        this.progressBar = document.createElement('div'); // Create progress bar container
        this.progressBar.classList.add('slider-progress'); // Add a class for styling
        this.progressBar.innerHTML = '<div class="progress"></div>'; // Inner progress element
        this.slider.parentElement.appendChild(this.progressBar); // Append the progress bar to the slider
        }
        super.connectedCallback();
    }

    init() {
        const sliderOptions = this.slider.parentElement.getAttribute("data-slider-options");
        if (!sliderOptions) return;

        const options = JSON.parse(sliderOptions);
        Object.keys(options).forEach(key => {
            if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
                options[key] = parseInt(options[key], 10);
            }
        });

        const autoplay = options.auto_play > 0 ? options.auto_play * 1000 : false;
        const loop = options.loop === "true" || options.loop === true;
        const centeredSlides = options.mode === "true" || options.mode === true;
        const pagination = options.dots === "true" || options.loop === true;

        const slickOptions = {
            infinite: loop,
            autoplay: !!autoplay,
            autoplaySpeed: autoplay,
            centerMode: centeredSlides,
            prevArrow: this.slider.parentElement.querySelector(".slick-prev"),
            nextArrow: this.slider.parentElement.querySelector(".slick-next"),               
            dots: pagination,            
            dotsClass: 'pagination pt-3',
            customPaging: function (slider, i) {            
                var slideNumber = (i + 1),
                totalSlides = slider.slideCount;
                return '<span class="page-link rounded-circle m-1 p-1"></span>';
            },
            lazyLoad: 'ondemand',
            slidesToShow: options.desktop,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 2560,
                    settings: {
                        slidesToShow: options.desktop,
                    }
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: options.laptop,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: options.tablet,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: options.mobile,
                    }
                }
            ],
            ...options.options 
        };

        // Initialize Slick slider
        $(this.slider).slick(slickOptions);

        // Calculate and update the progress bar on slide change
        const totalSlides = $(this.slider).slick('getSlick').slideCount;
        const updateProgressBar = (currentSlide) => {
            const progress = ((currentSlide + 1) / totalSlides) * 100;
            this.progressBar.querySelector('.progress').style.width = `${progress}%`;
        };

        // Initial progress bar update
        updateProgressBar(0);

        // Listen to slide change events to update the progress bar
        $(this.slider).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            updateProgressBar(nextSlide);
        });
    }
}

customElements.define('wdt-fcollection-slider', WDT_Fcollection);


document.addEventListener('DOMContentLoaded', function() {   
   slickCall();
  cardSwatch();
});

 $(document).ready(function() {   
   if($('.section-number-counter').length > 0){
    function runCounter($element) {
      var max_value = $element.attr('data-value');
      $({
        counter_value: $element.text()
      }).animate({
        counter_value: max_value
      }, {
        step: function step() {
          $element.text(Math.floor(this.counter_value));
        },
        duration: 1500,
        easing: 'swing',
        complete: function complete() {
          $element.text(this.counter_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")); 
        }
      });
    }

    var observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 
    };

    var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var $element = $(entry.target);
          runCounter($element);
          observer.unobserve(entry.target); 
        }
      });
    }, observerOptions);

    $('.number-counter-value').each(function() {
      observer.observe(this);
    });
   } 

//cookie banner 
   var cookie = false;
    var cookieContent = $('.cookie-disclaimer');    
    checkCookie();
    if (cookie === false) {
      cookieContent.css("display","flex");
    }
    
    if (cookie === true) {
      cookieContent.css("display","none");
    }
    
    function setCookie(cname, cvalue, exdays) {
  		var d = new Date();
  		d.setTime(d.getTime() + (exdays*24*60*60*1000));
  		var expires = "expires="+ d.toUTCString();
  		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    	console.log(cname + "=" + cvalue + ";" + expires + ";path=/");
	}
    
    function getCookie(cname) {
  		var name = cname + "=";
  		var decodedCookie = decodeURIComponent(document.cookie);
  		var ca = decodedCookie.split(';');
  		for(var i = 0; i < ca.length; i++) {
    	var c = ca[i];
    	while (c.charAt(0) == ' ') {
      	c = c.substring(1);
    	}
    	if (c.indexOf(name) == 0) {
      		return c.substring(name.length, c.length);
    	}
  		}
  		return "";
	}
    
    function checkCookie() {
      var user = getCookie("hldn_consent_choice");
      if (user !== "") {        
        cookie = true;
        if (user === "accepted") {                  
        }
      }
    }

    $('.accept-cookie').click(function () {
      setCookie("hldn_consent_choice", "accepted", 365);
      cookieContent.css("display","none");
    });

    $('.decline-cookie').click(function () {    
      setCookie("hldn_consent_choice", "declined", 365);
      cookieContent.css("display","none");
    });

   // Sugessted Items
   if ($.cookie('dT_suggested-cookie') == 'closed') {
    $('.customer-who-purchased').remove();
  }

  $('.dT_close').bind('click',function(){
    $('.customer-who-purchased').remove();
    $.cookie('dT_suggested-cookie', 'closed', {expires:1, path:'/'});
  });      

  var elements = $('.customer-who-purchased li');
  var init_element = 0;
  var i = 0;
 
  elements.removeClass('active');
  function fadeInRandomElement() { 
    if ( i % 2 == 0) {
      var currentItem = elements.eq(init_element);      
      currentItem.addClass('active');
      setTimeout(function(){ 
        currentItem.removeClass('active')
      }, 8000);

      init_element++;
      if(elements.length == init_element) {
        init_element = 0;
      }

    }
    i++;
  }
  setInterval(function(){ 
    fadeInRandomElement();
  }, 8000);   
});

  AOS.init({
    startEvent: 'DOMContentLoaded',
    once: true,
    offset: 50, 
    delay: 0, 
    duration: 1000    
  });
  window.addEventListener('load', function() {
    AOS.refresh();
  });
 
document.addEventListener('shopify:block:deselect', function (event) {
  $('.carousel-thumbnail_slider').slick('unslick');
   slickCall();
});

document.addEventListener('shopify:section:load', () => {
  slickCall();
});

function cardSwatch() {
   $("body").on("click", ".item-swatch span", function () {    
    var featuredMedia = $(this).parents(".card-main").find(".card__inner .featured-media").attr("srcset", $(this).data("image"));      
    if ($(this).parents(".card-swatch").hasClass("color")) {
      const variant = $(this).data("id");
      $(this).parents(".card-main").find(".product-variant-id").val(variant);
      var swatch_item = $(this).data("variant-item");
  };
});
}


class VerticalBar extends HTMLElement {
    constructor() {
      super();
      this.container = document.querySelector('.vertical-marquee-selector');
      
      // Initialize Slick
      $(this.container).slick({
        vertical: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 1000,
        nextArrow: this.container.parentElement.querySelector('.vertical-marquee-next'),
        prevArrow: this.container.parentElement.querySelector('.vertical-marquee-prev')
      });
    }
  }
  customElements.define('vertical-bar', VerticalBar);



 
